import React from "react";
import { Box, Typography, Link, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { typo } from "../../../../assets/fonts/font";
import colorConfigs from "../../../../configs/colorConfigs";

export const CheckoutHeader = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography sx={{ ...typo.title }} gutterBottom>
        Checkout
      </Typography>
      <Link
        href="#"
        sx={{ 
          ...typo.bodyContent,
          display: "block", 
          mb: 2,
          textDecoration: "underline",
          color: colorConfigs.tertiary,
          "&:hover": {
            color: colorConfigs.primary,
          }
        }}
        onClick={(e) => {
          e.preventDefault();
          navigate(-1);
        }}
      >
        Back to cart
      </Link>
      <Divider
        sx={{
          my: 1,
          borderColor: colorConfigs.primary,
          opacity: 0.5,
          borderWidth: "1px",
        }}
      />
    </Box>
  );
};